const styleRegex = /(auto|scroll)/

const style = (node: Element, prop: string) => window.getComputedStyle(node, null).getPropertyValue(prop)

const scroll = (node: Element) => styleRegex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'))

export function getScrollParent(node: Element) {
  while (node !== document.body) {
    if (scroll(node)) return node as HTMLElement
    node = node.parentElement!
  }
  return window
}
